import { Translation } from '@fullyops/shared/pipes/translate.pipe';
import { AssetFormTranslationKey } from './translate.pipe';

export const pt: Translation<AssetFormTranslationKey> = {
  name: 'Nome',
  assetType: 'Tipo de ativo',
  STANDALONE_EQUIPMENT: 'Equipamento individual',
  EQUIPMENT_GROUP: 'Grupo de equipamentos',
  generic: 'genérico',
  active: 'Ativado',
  createdAt: 'Criado a',
  company: 'Empresa',
  companies: 'Empresas',
  category: 'Categoria',
  location: 'Localização',
  locations: 'Localizações',
  parent: 'Ativo pai',
  description: 'Descrição',
  externalId: 'Identificador externo',
  criticality: 'Criticidade',
  LOW: 'Baixa',
  MEDIUM: 'Média',
  HIGH: 'Alta',
  CRITICAL: 'Crítica',
  installedAt: 'Instalado a',
  hasWarranty: 'Tem garantia',
  warrantyExpiresAt: 'Garantia expira em',
  warranty: 'Garantia',
  brand: 'Marca',
  model: 'Modelo',
  serialNumber: 'Número de série',
  type: 'Tipo',
  manufacturedAt: 'Fabricado a',
  noneCriticality: 'Nenhuma',
  noneGeneric: 'Nenhum',
  any: 'Qualquer',
  assetClass: 'Classe de ativo',
  noWarranty: 'Não definida',
  inWarranty: 'Em garantia',
  outOfWarranty: 'Fora de garantia',
  create: 'Criar',
  assetsPerPage: 'Ativos por página',
  inactive: 'Desativado',
  change: 'Alterar',
  genericType: 'Genérico',
  noCustomFields: 'Sem campos personalizados',
  oneCustomField: '1 campo personalizado',
  customFields: 'campos personalizados',
  chooseAssetType: 'Escolha o tipo de ativo',
  general: 'Informação geral',
  ownershipAndLocation: 'Proprietário e localização',
  installationAndWarranty: 'Instalação e garantia',
  equipmentDetails: 'Detalhes do equipamento',
  customFieldsSection: 'Campos personalizados',
  attachments: 'Anexos',
  generalDescription: 'O que é o ativo e quão crítico é',
  ownershipAndLocationDescription:
    'A quem pertence, onde está e de que faz parte',
  installationAndWarrantyDescription:
    'Quando foi instalado e até quando está em garantia',
  equipmentDetailsDescription:
    'Dados do fabricante que identificam o equipamento',
  customFieldsSectionDescription: 'Campos definidos para este tipo de ativo',
  invalidInteger: 'Introduza um número inteiro, p. ex. 12',
  invalidDecimal: 'Introduza um número, p. ex. 12,5',
  status: 'Estado',
  valueOutOfRange: 'Fora do intervalo permitido:',
  attachmentsDescription:
    'Manuais, certificados, fotografias e outros ficheiros',
  openAsset: 'Abrir ativo',
  close: 'Fechar',
  save: 'Guardar',
  add: 'Adicionar',
  noCompanyAssets: 'Este cliente ainda não tem ativos',
};
